import { PageHeader, Button, useOpenClose } from "@evertrue/et-components";
import FormField from "components/forms/form-field";
import ControlledMaskedInput from "components/forms/controlled-masked-input";
import ValidatePhoneModal from "../../modals/validate-phone-modal";
import useCallSettings from "../../../hooks/use-call-settings";
import PropTypes from "prop-types";

const FormFieldWithMaskedInput = ({ label, placeholder, value, onChange, mask, className }) => (
  <FormField label={label} inlineLabel={false} className={`call-settings-${className}-label`}>
    <ControlledMaskedInput
      type="text"
      mask={mask}
      placeholder={placeholder}
      placeholderChar="|"
      value={value}
      className={`call-settings-${className}-input`}
      onChange={onChange}
    />
  </FormField>
);

const CallSettings = () => {
  const {
    etNumber,
    callerIdNumber,
    setCallerIdNumber,
    fowardingNumber,
    setFowardingNumber,
    handleSubmit,
    validatePhoneNumber,
    validated,
    callSid,
    validationCode,
    checkValidationStatus,
  } = useCallSettings();
  const [isValidationModalOpen, openValidationModal, closeValidationModal] = useOpenClose();
  // api call to validate that the code that the user entered is correct

  const mask = ["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];

  const handleValidationClick = async () => {
    await validatePhoneNumber(callerIdNumber, openValidationModal);
  };

  const onClose = async () => {
    await checkValidationStatus(callSid, 1000, closeValidationModal);
  };

  return (
    <>
      <PageHeader title="Calls" className="call-settings-header" />
      <p className="call-settings-etnumber-header">Your EverTrue Number</p>
      <FormField
        inlineLabel={false}
        label="This is the EverTrue number assigned to you by your team admin."
        className="call-settings-etnumber-label"
      >
        <input
          className="call-settings-etnumber-input"
          type="text"
          placeholder="(111) 111-1111"
          value={etNumber}
          disabled
        />
      </FormField>

      <p className="call-settings-custom-number-header">Custom Caller ID Number</p>
      <div className="call-settings-custom-number-div">
        <FormFieldWithMaskedInput
          placeholder="(111) 111-1111"
          label="This number will appear on the call recipient’s caller ID in place of your EverTrue number. To use this feature you must verify that you own the number entered here. Please be sure to complete steps requested and end the call before closing the pop-up verification code window."
          value={callerIdNumber}
          onChange={(number) => setCallerIdNumber(number)}
          mask={mask}
          className="custom-number"
        />
        <div className="call-settings-custom-number-verify">
          <Button onClick={handleValidationClick} className="call-settings-verify-button">
            Verify
          </Button>
        </div>
      </div>
      <div className="call-settings-custom-number-save">
        <Button onClick={handleSubmit} disabled={!validated}>
          Save
        </Button>
      </div>

      <div className="call-settings-separator"></div>

      <PageHeader title="Inbound Call Settings" className="call-settings-inbound-header" />
      <p className="call-settings-frwd-number-header">Forwarding Number</p>
      <FormFieldWithMaskedInput
        placeholder="(111) 111-1111"
        label="Inbound calls will forward to this number. Your forwarding number should not be your assigned number."
        value={fowardingNumber}
        onChange={(number) => setFowardingNumber(number)}
        mask={mask}
        className="frwd-number"
      />
      <div className="call-settings-frwd-number-save">
        <Button onClick={handleSubmit} disabled={true}>
          Save
        </Button>
      </div>
      <ValidatePhoneModal code={validationCode} isOpen={isValidationModalOpen} onClose={onClose} />
    </>
  );
};

FormFieldWithMaskedInput.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  mask: PropTypes.array.isRequired,
  className: PropTypes.string.isRequired,
};

export default CallSettings;
